import { render, staticRenderFns } from "./SpecialBonusesPage.vue?vue&type=template&id=28becabd&"
import script from "./SpecialBonusesPage.vue?vue&type=script&lang=js&"
export * from "./SpecialBonusesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports